import { render, staticRenderFns } from "./AdministratorsList.vue?vue&type=template&id=568ffa83&scoped=true&"
import script from "./AdministratorsList.vue?vue&type=script&lang=js&"
export * from "./AdministratorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568ffa83",
  null
  
)

export default component.exports